var _classCallCheck = require("/home/kotborealis/projects/lua-trans/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/kotborealis/projects/lua-trans/app/node_modules/@babel/runtime/helpers/createClass");

module.exports =
/*#__PURE__*/
function () {
  "use strict";

  function _class() {
    _classCallCheck(this, _class);

    this.inside_loop = [];
    this.break_loop = [];
    this.inside_fn = [];
    this.return_ = [];
  }

  _createClass(_class, [{
    key: "insideLoopPush",
    value: function insideLoopPush() {
      return this.inside_loop.push(true);
    }
  }, {
    key: "insideLoopPop",
    value: function insideLoopPop() {
      return this.inside_loop.pop();
    }
  }, {
    key: "insideLoop",
    value: function insideLoop() {
      return !!this.inside_loop[this.inside_loop.length - 1];
    }
  }, {
    key: "breakLoopPush",
    value: function breakLoopPush() {
      return this.break_loop.push(true);
    }
  }, {
    key: "breakLoopPop",
    value: function breakLoopPop() {
      return this.break_loop.pop();
    }
  }, {
    key: "breakLoop",
    value: function breakLoop() {
      return !!this.break_loop[this.break_loop.length - 1];
    }
  }, {
    key: "insideFnPush",
    value: function insideFnPush() {
      return this.inside_fn.push(true);
    }
  }, {
    key: "insideFnPop",
    value: function insideFnPop() {
      return this.inside_fn.pop();
    }
  }, {
    key: "insideFn",
    value: function insideFn() {
      return !!this.inside_fn[this.inside_fn.length - 1];
    }
  }, {
    key: "returnPush",
    value: function returnPush(value) {
      return this.return_.push(value);
    }
  }, {
    key: "returnPop",
    value: function returnPop() {
      return this.return_.pop();
    }
  }, {
    key: "return",
    value: function _return() {
      return !!this.return_[this.return_.length - 1];
    }
  }]);

  return _class;
}();